import type { CSSProperties } from 'react'
import { POOL, img } from './media'

const HEIGHTS = [520, 640, 460, 700, 560, 600]
const DURS = ['78s', '96s', '68s', '88s', '104s', '74s']
const DIRS = ['normal', 'reverse', 'normal', 'reverse', 'normal', 'reverse']

function buildColumns(cols: number, perCol: number) {
  const out: { seed: string; h: number }[][] = []
  let k = 0
  for (let c = 0; c < cols; c++) {
    const col: { seed: string; h: number }[] = []
    for (let r = 0; r < perCol; r++) {
      col.push({ seed: POOL[k % POOL.length], h: HEIGHTS[(c + r) % HEIGHTS.length] })
      k++
    }
    out.push(col)
  }
  return out
}

type Props = { columns?: number; perCol?: number; lazy?: boolean }

// Animated, drifting wall of photos behind the hero / CTA band. Decorative only.
// `lazy` (for the below-the-fold CTA band) loads every image lazily; the hero
// eager-loads only the first image per column so the initial paint isn't
// blocked on the whole wall.
export function ThumbWall({ columns = 6, perCol = 6, lazy = false }: Props) {
  const cols = buildColumns(columns, perCol)
  return (
    <div className="pd-wall" aria-hidden="true">
      {cols.map((col, ci) => (
        <div
          className="pd-wall-col"
          key={ci}
          style={{ '--dur': DURS[ci % DURS.length], '--dir': DIRS[ci % DIRS.length] } as CSSProperties}
        >
          {[...col, ...col].map((it, i) => (
            <img
              key={i}
              src={img(it.seed, 400, it.h)}
              width={400}
              height={it.h}
              loading={!lazy && i === 0 ? 'eager' : 'lazy'}
              alt=""
            />
          ))}
        </div>
      ))}
    </div>
  )
}
